import { render } from "./hoverEffect12.vue?vue&type=template&id=87c31396"
import script from "./hoverEffect12.vue?vue&type=script&lang=js"
export * from "./hoverEffect12.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__